module.exports = __webpack_public_path__ + "assets/img/silver.6c58889c.png";